import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { moduleAction } from "../../utils/functions";
import { MOD_BILL, WRITE } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import Bills from "../../../../static/images/bills-new.svg";
import addBill from "../../../../static/images/Add-Bill.svg";

export class BlankBill extends Component {
  render() {
    const { roles, t } = this.props;

    return (
      <React.Fragment>
        <div className="main">
          <img className="billImage" src={Bills} />
          <p className="p-fix">{t('invoices.blank.title')}</p>
          <div className="line bill-line"></div>
          <h3>{t('invoices.blank.description')}</h3>

          {moduleAction(roles, MOD_BILL, WRITE) && (
            <Link className="blank-btn" to="/bills/add">
              <img className="button" src={addBill} />
            </Link>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = state => {
  return {
    roles: getRoles(state)
  };
};


export default connect(mapStateToProps, null)(withTranslation()(BlankBill));
